import React, { useState } from "react"
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap"
import { FormattedMessage, FormattedNumber, injectIntl } from "react-intl"
import { withRouter } from "react-router-dom"
import { Intl } from "../../../state/helpers/IntlProps"
import Item from "../../../state/pricing/Item"
import { PricingRowDto } from "../../../state/pricing/PricingRow"
import Icon from "../../icon/icon.component"

type OwnProps = {
    children: (boolean) => React.Component
    onChange: (unitPrice: string | number) => void
    isPricingTable: boolean
    unitPrice:number|string
    item: PricingRowDto
    intl: Intl
}
const PriceWarningWrapper = (props: OwnProps) => {
    const [buttonHide, setButtonHide] = useState<boolean>(false)
    const [showTooltip, setShowTooltip] = useState<boolean>(false)

    let itemObject: Item | undefined = undefined
    if (props.isPricingTable && props.item?.attributes.itemObject) {
        itemObject = new Item(props.item.attributes.itemObject)
    }

    if (!buttonHide && props.isPricingTable &&
        !itemObject?.isCurrentUnitPriceSameAsDefaultUnitPrice(props.unitPrice, props.item.attributes.priceLevelId)) {
        return (<>
            <div key={"tooltip-container"} data-tip data-for={`priceWarningLock${props.item.id}`} >
                <OverlayTrigger
                    placement={"top"}
                    show={showTooltip}
                    overlay={<Tooltip id="tooltip_price_edit">
                        <div className="d-flex flex-column">
                            {props.item.attributes.priceLevelId?
                                <FormattedMessage
                                    id="workflow.form.edit.different_price_price_level_message"
                                    defaultMessage="Your item has a different price for the selected price level. 
                                    Do you want to change it to {unitPrice}?"
                                    values={{
                                        unitPrice: <FormattedNumber
                                            style="currency"
                                            currency={props.item.attributes.currency}
                                            value={itemObject?.getPriceFromPriceLevel(props.item.attributes.priceLevelId)} />,
                                    }}
                                />:
                                <FormattedMessage
                                    id="workflow.form.edit.different_price_message"
                                    defaultMessage="Your item has a different price in the product
                                 catalog. Do you want to change it to {unitPrice}?"
                                    values={{
                                        unitPrice: <FormattedNumber
                                            style="currency"
                                            currency={props.item.attributes.currency}
                                            value={props.item.attributes.itemObject.attributes.defaultUnitPrice} />,
                                    }}
                                />}
                            <div className="d-inline-flex justify-content-end">
                                <Button variant="outline-danger" size="sm"
                                    style={{ fontSize: "0.5rem", marginRight: "0.25rem", marginTop: "0.25rem" }}
                                    onClick={() => {
                                        setButtonHide(true)
                                    }}>
                                    <Icon value="times" />
                                </Button>

                                <Button variant="outline-success" size="sm"
                                    style={{ fontSize: "0.5rem", maxWidth: "160px", marginTop: "0.25rem" }}
                                    onClick={() => {
                                        const newPrice=props.item.attributes.priceLevelId?
                                            itemObject?.getPriceFromPriceLevel(props.item.attributes.priceLevelId):
                                            props.item.attributes.itemObject.attributes.defaultUnitPrice
                                        props.onChange(Number(newPrice).toString())
                                    }}>
                                    <Icon value="check" />
                                </Button>
                            </div>
                        </div>
                    </Tooltip>}
                >
                    <div className="d-flex flex-column" onFocus={() => setShowTooltip(!showTooltip)}>
                        {props.children(!buttonHide)}
                    </div>
                </OverlayTrigger>
            </div>
        </>)
    }
    return props.children(false)
}
export default withRouter(injectIntl(PriceWarningWrapper))


// WEBPACK FOOTER //
// ./src/common/quote/component/ItemPriceWrapperWarning.tsx